export enum StageEnum {
    creche = 1,
    preEscola = 2,
    ensinoFundamentalAnosIniciais = 3,
    ensinoFundamentalAnosFinais = 4,
    ensinoMedio = 5,
    eja = 6
}
